const specialNominations = [
    {
        id: '22',
        title: 'Человек года',
        description: 'Победитель определяется среди кандидатов с наивысшим коэффициентом полезной активности по итогам открытого онлайн-голосования на «Форуме» Банки.ру',
    },
];

export default specialNominations;
